import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export function saleEndsLabel(ends) {
  if (!ends) return null;
  const s = String(ends);
  const end = s.length > 10 ? new Date(s) : new Date(`${s}T23:59:59`);
  const ms = end.getTime() - Date.now();
  if (Number.isNaN(ms) || ms <= 0) return null;
  const h = Math.floor(ms / 3600000);
  const d = Math.floor(h / 24);
  if (d >= 1) return `${d}d ${h % 24}h`;
  if (h >= 1) return `${h}h ${Math.floor((ms % 3600000) / 60000)}m`;
  return `${Math.max(1, Math.floor(ms / 60000))}m`;
}

export default function SaleCountdown({ ends, compact = false, testid = "sale-countdown" }) {
  const [label, setLabel] = useState(() => saleEndsLabel(ends));
  useEffect(() => {
    setLabel(saleEndsLabel(ends));
    const t = setInterval(() => setLabel(saleEndsLabel(ends)), 60000);
    return () => clearInterval(t);
  }, [ends]);
  if (!label) return null;
  if (compact) return (
    <span data-testid={testid} className="inline-flex items-center gap-1 text-[11px] font-display font-bold text-[#FF6B9D]">
      <Clock className="w-3 h-3" /> Sale ends in {label}
    </span>
  );
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full bg-[#FF6B9D]/12 border border-[#FF6B9D]/30 px-3 py-1 text-xs font-display font-bold text-[#FF6B9D] animate-pulse">
      <Clock className="w-3.5 h-3.5" /> Sale ends in {label}
    </span>
  );
}
